import Image from 'next/image';
import clsx from 'clsx';

import styles from './styles.module.css';

type Props = {
  alt?: string;
  image?: string;
  width?: number;
  height?: number;
};

type WrapperProps = React.PropsWithChildren & {
  size?: number;
  className?: string;
};

export const LogoOverlayWrapper = ({
  children,
  size,
  className,
}: WrapperProps) => {
  return (
    <div
      className={clsx(styles.wrapper, size && styles.wrapperCompact, className)}
      style={
        size
          ? {
              width: size,
              height: size,
              flex: `0 0 ${size}px`,
            }
          : undefined
      }
    >
      {children}
    </div>
  );
};

export const LogoOverlay = ({ alt, image, width, height }: Props) => {
  if (!image) {
    return null;
  }

  if (width && height) {
    return (
      <div className={styles.containerFixed}>
        <Image
          src={image}
          alt={alt ?? image + ' logo'}
          width={width}
          height={height}
          style={{ objectFit: 'contain', objectPosition: 'center' }}
        />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Image
        src={image}
        alt={alt ?? image + ' logo'}
        fill
        sizes="(max-width: 769px) 160px, 290px"
        style={{ objectFit: 'contain', objectPosition: 'center' }}
      />
    </div>
  );
};
